/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The cabin.
 * @export
 * @interface Cabin
 */
export interface Cabin {
    /**
     * Is there a baby bed possible in cabin.
     * @type {boolean}
     * @memberof Cabin
     */
    babyBed?: boolean;
    /**
     * Size of balcony
     * @type {number}
     * @memberof Cabin
     */
    balcony?: number;
    /**
     * Type of balcony
     * @type {string}
     * @memberof Cabin
     */
    balconyType?: string;
    /**
     * Number of beds
     * @type {number}
     * @memberof Cabin
     */
    beds?: number;
    /**
     * The cabin category code.
     * @type {string}
     * @memberof Cabin
     */
    cabinCategoryCode: string;
    /**
     * The cabin number.
     * @type {string}
     * @memberof Cabin
     */
    cabinNumber: string;
    /**
     * Number of ceiling pullman-beds
     * @type {number}
     * @memberof Cabin
     */
    ceilingPullmans?: number;
    /**
     * Expresses if cabin is close to a restaurant
     * @type {boolean}
     * @memberof Cabin
     */
    closeToRestaurant?: boolean;
    /**
     * Expresses if cabin is close to stairs
     * @type {boolean}
     * @memberof Cabin
     */
    closeToStairs?: boolean;
    /**
     * Expresses if cabin is close to wellness
     * @type {boolean}
     * @memberof Cabin
     */
    closeToWellness?: boolean;
    /**
     * Cabin number of connected cabin. Null if no cabin is connected
     * @type {string}
     * @memberof Cabin
     */
    connectedCabinNumber?: string;
    /**
     * The deck number.
     * @type {number}
     * @memberof Cabin
     */
    deck?: number;
    /**
     * Beds heading into direction of travel
     * @type {boolean}
     * @memberof Cabin
     */
    directionOfTravel?: boolean;
    /**
     * Number of double-beds
     * @type {number}
     * @memberof Cabin
     */
    doubleBeds?: number;
    /**
     * Is the cabin handicapped accessible.
     * @type {boolean}
     * @memberof Cabin
     */
    handicappedAccessible?: boolean;
    /**
     * URL to retrieve picture of cabin layout
     * @type {string}
     * @memberof Cabin
     */
    layoutImageUrl?: string;
    /**
     * Indicator if visibility is limited
     * @type {boolean}
     * @memberof Cabin
     */
    limitedVisibility?: boolean;
    /**
     * The location of the cabin.
     * * A: Aft ship
     * * M: Midships
     * * F: Fore ship
     * 
     * @type {string}
     * @memberof Cabin
     */
    location?: string;
    /**
     * The code of the main cabin category
     * @type {string}
     * @memberof Cabin
     */
    mainCategoryCode?: string;
    /**
     * Maximum people per cabin
     * @type {number}
     * @memberof Cabin
     */
    maxOccupancy?: number;
    /**
     * Indicator that windows are portholes
     * @type {boolean}
     * @memberof Cabin
     */
    portholes?: boolean;
    /**
     * Number of separated beds
     * @type {number}
     * @memberof Cabin
     */
    sepBeds?: number;
    /**
     * Indicator if sundeck is seperate
     * @type {boolean}
     * @memberof Cabin
     */
    sepSundeck?: boolean;
    /**
     * The side of the cabin.
     * * S: starboard
     * * P: port
     * 
     * @type {string}
     * @memberof Cabin
     */
    side?: string;
    /**
     * The size of the cabin in sqm.
     * @type {number}
     * @memberof Cabin
     */
    size?: number;
    /**
     * Number of sofa beds
     * @type {number}
     * @memberof Cabin
     */
    sofaBeds?: number;
    /**
     * Cabin has two bathrooms
     * @type {boolean}
     * @memberof Cabin
     */
    twoBathrooms?: boolean;
    /**
     * URL to retrieve 3D picture of cabin
     * @type {string}
     * @memberof Cabin
     */
    viewImageUrl?: string;
    /**
     * Cabin has walk in wardrobe
     * @type {boolean}
     * @memberof Cabin
     */
    walkInWardrobe?: boolean;
    /**
     * Number of wall pullman-beds
     * @type {number}
     * @memberof Cabin
     */
    wallPullmans?: number;
}

/**
 * Check if a given object implements the Cabin interface.
 */
export function instanceOfCabin(value: object): value is Cabin {
    if (!('cabinCategoryCode' in value) || value['cabinCategoryCode'] === undefined) return false;
    if (!('cabinNumber' in value) || value['cabinNumber'] === undefined) return false;
    return true;
}

export function CabinFromJSON(json: any): Cabin {
    return CabinFromJSONTyped(json, false);
}

export function CabinFromJSONTyped(json: any, ignoreDiscriminator: boolean): Cabin {
    if (json == null) {
        return json;
    }
    return {
        
        'babyBed': json['babyBed'] == null ? undefined : json['babyBed'],
        'balcony': json['balcony'] == null ? undefined : json['balcony'],
        'balconyType': json['balconyType'] == null ? undefined : json['balconyType'],
        'beds': json['beds'] == null ? undefined : json['beds'],
        'cabinCategoryCode': json['cabinCategoryCode'],
        'cabinNumber': json['cabinNumber'],
        'ceilingPullmans': json['ceilingPullmans'] == null ? undefined : json['ceilingPullmans'],
        'closeToRestaurant': json['closeToRestaurant'] == null ? undefined : json['closeToRestaurant'],
        'closeToStairs': json['closeToStairs'] == null ? undefined : json['closeToStairs'],
        'closeToWellness': json['closeToWellness'] == null ? undefined : json['closeToWellness'],
        'connectedCabinNumber': json['connectedCabinNumber'] == null ? undefined : json['connectedCabinNumber'],
        'deck': json['deck'] == null ? undefined : json['deck'],
        'directionOfTravel': json['directionOfTravel'] == null ? undefined : json['directionOfTravel'],
        'doubleBeds': json['doubleBeds'] == null ? undefined : json['doubleBeds'],
        'handicappedAccessible': json['handicappedAccessible'] == null ? undefined : json['handicappedAccessible'],
        'layoutImageUrl': json['layoutImageUrl'] == null ? undefined : json['layoutImageUrl'],
        'limitedVisibility': json['limitedVisibility'] == null ? undefined : json['limitedVisibility'],
        'location': json['location'] == null ? undefined : json['location'],
        'mainCategoryCode': json['mainCategoryCode'] == null ? undefined : json['mainCategoryCode'],
        'maxOccupancy': json['maxOccupancy'] == null ? undefined : json['maxOccupancy'],
        'portholes': json['portholes'] == null ? undefined : json['portholes'],
        'sepBeds': json['sepBeds'] == null ? undefined : json['sepBeds'],
        'sepSundeck': json['sepSundeck'] == null ? undefined : json['sepSundeck'],
        'side': json['side'] == null ? undefined : json['side'],
        'size': json['size'] == null ? undefined : json['size'],
        'sofaBeds': json['sofaBeds'] == null ? undefined : json['sofaBeds'],
        'twoBathrooms': json['twoBathrooms'] == null ? undefined : json['twoBathrooms'],
        'viewImageUrl': json['viewImageUrl'] == null ? undefined : json['viewImageUrl'],
        'walkInWardrobe': json['walkInWardrobe'] == null ? undefined : json['walkInWardrobe'],
        'wallPullmans': json['wallPullmans'] == null ? undefined : json['wallPullmans'],
    };
}

export function CabinToJSON(json: any): Cabin {
    return CabinToJSONTyped(json, false);
}

export function CabinToJSONTyped(value?: Cabin | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'babyBed': value['babyBed'],
        'balcony': value['balcony'],
        'balconyType': value['balconyType'],
        'beds': value['beds'],
        'cabinCategoryCode': value['cabinCategoryCode'],
        'cabinNumber': value['cabinNumber'],
        'ceilingPullmans': value['ceilingPullmans'],
        'closeToRestaurant': value['closeToRestaurant'],
        'closeToStairs': value['closeToStairs'],
        'closeToWellness': value['closeToWellness'],
        'connectedCabinNumber': value['connectedCabinNumber'],
        'deck': value['deck'],
        'directionOfTravel': value['directionOfTravel'],
        'doubleBeds': value['doubleBeds'],
        'handicappedAccessible': value['handicappedAccessible'],
        'layoutImageUrl': value['layoutImageUrl'],
        'limitedVisibility': value['limitedVisibility'],
        'location': value['location'],
        'mainCategoryCode': value['mainCategoryCode'],
        'maxOccupancy': value['maxOccupancy'],
        'portholes': value['portholes'],
        'sepBeds': value['sepBeds'],
        'sepSundeck': value['sepSundeck'],
        'side': value['side'],
        'size': value['size'],
        'sofaBeds': value['sofaBeds'],
        'twoBathrooms': value['twoBathrooms'],
        'viewImageUrl': value['viewImageUrl'],
        'walkInWardrobe': value['walkInWardrobe'],
        'wallPullmans': value['wallPullmans'],
    };
}

